import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useSocket } from '@/contexts/SocketContext';
import { useAuth } from '@/contexts/AuthContext';

export default function MessengerLayout() {
  const { socket } = useSocket();
  const { user } = useAuth();

  useEffect(() => {
    if (!socket || !user) return;

    socket.emit(`subscribe:messenger:${user.tenantId || user.tenant_id}`, {});

    socket.emit('messenger:heartbeat', { status: 'online' });

    const heartbeat = setInterval(() => {
      socket.emit('messenger:heartbeat', { status: 'online' });
    }, 30000);

    return () => {
      clearInterval(heartbeat);
      socket.emit(`unsubscribe:messenger:${user.tenantId || user.tenant_id}`, {});
    };
  }, [socket, user]);

  return (
    <div className="h-full -m-3 sm:-m-4 md:-m-6 overflow-hidden">
      <Outlet />
    </div>
  );
}
